import GlobalStyle from "./styles/global";
import React, { useState, useEffect } from 'react';
import axios from './utils/axios';
import Navbar from './components/Navbar';
import CardProduct from './components/CardProduct';
import Footer from './components/Footer';
import { Product } from './models/Product';

const App: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [error, setError] = useState<string | null>(null);

  const getProducts = async () => {
    try {
      const res = await axios.get<{ products: Product[] }>("products?page=1&rows=15&sortBy=id&orderBy=DESC");
      setProducts(res.data.products);
      setError(null);
    } catch (error) {
      setError('Ocorreu um erro ao obter os produtos. Por favor, tente novamente mais tarde.');
      console.error('Erro:', error);
    }
  };

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <>
      <Navbar />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '85vh' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '20px', width: '70%' }}>
          {products.map((product) => (
            <CardProduct key={product.id} product={product} />
          ))}
        </div>
      </div>
      <Footer />
      <GlobalStyle />
    </>
  );
};

export default App;